import debug from 'debug';

export default debug('kinderlime');
